import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'animate.css'
import WOW from 'wow.js'
import './plugins/axios.js'
import './assets/css/style.scss'
import mixin from './mixin.js'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import BreadCrumb from './components/BreadCrumb.vue'
import searchBox from './components/SearchBox.vue'
import inputSearch from './components/inputSearch.vue'
import esimModel from './components/EsimModel.vue'

// import AOS from 'aos'
// import 'aos/dist/aos.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// VCalendar
import VCalendar from 'v-calendar'

/* import the fontawesome core */
/* import font awesome icon component */
/* import specific icons */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// solid
import { faGolfBallTee, fa1, fa2, fa3, fa4 } from '@fortawesome/free-solid-svg-icons'
// regular
import { faHandshake, faThumbsUp } from '@fortawesome/free-regular-svg-icons'

// swiper5、VueAwesomeSwiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import VueMeta from 'vue-meta'

import i18n from './i18n'

import VueEasyLightbox from 'vue-easy-lightbox'

import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)
Vue.use(VueEasyLightbox)

Vue.use(VueMeta)

const wow = new WOW(
  {
    boxClass: 'wow', // default
    animateClass: 'animate__animated',
    offset: 0, // default
    mobile: true, // default
    live: true // default
  }
)
wow.init()

// AOS.init()

Vue.use(VueAwesomeSwiper)

/* fontawesome add icons to the library */
library.add(faGolfBallTee, faHandshake, faThumbsUp, fa1, fa2, fa3, fa4)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('esimModel', esimModel)
Vue.component('inputSearch', inputSearch)
Vue.component('BreadCrumb', BreadCrumb)
Vue.component('search-box', searchBox)

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  screens: {
    sm: '300px'
  }
})
Vue.use(VueSweetalert2)
Vue.mixin(mixin)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false

// 註銷serviceWorker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister()
    }
  }).catch(error => {
    console.log('Error unregistering service workers:', error)
  })
}
// 換頁時滾動置頂
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
